/**
 * Service used to share content to social network
 */
export class SocialShareService {
    /**
     * Linkdin url to share
     * @param urlToShare: string
     * @param title: string
     * @param summary: string
     * @returns link share
     */
    static linkedinShareLink(urlToShare, title, summary) {
        return `http://www.linkedin.com/shareArticle?mini=true&title=${encodeURI(title)}&summary=${encodeURI(summary)}&url=${encodeURI(urlToShare)}`;
    }
    /**
     * Facebook share link
     * @param urlToShare : string
     * @param title : string
     * @returns link share
     */
    static facebookShareLink(urlToShare, title) {
        return `https://www.facebook.com/sharer/sharer.php?u=${encodeURI(urlToShare)}&t=${encodeURI(title)}`;
    }
    /**
     * Twitter link share
     * @param text: strig text to share
     * @returns link to share
     */
    static twitterShareLink(text) {
        return encodeURI(`https://twitter.com/intent/tweet?text=${text}`);
    }
    /**
     * Whats app url share
     * @param text: string
     * @returns link to sharz
     */
    static whatsappShareLink(text) {
        return `https://wa.me/?text=${encodeURI(text)}`;
    }
    /**
     * url to do a mail
     * @param emailAddress: string
     * @param title: string
     * @param text: string
     * @returns mailto link
     */
    static mailShareLink(toEmailAddress, title, text) {
        return `mailto:${toEmailAddress}?subject=${title}&body=${text}`;
    }
}
